import React from 'react'
import ComplexNavbar from '../navbar/Navbar'
import Gallery from '../Gallery/gallery'
import Footer from '../Footer/footer'
import Card from '../Card/Card'
import MainGaller from '../Gallery/MainGaller'
import Feature from '../Features/Feature'
import CarouselCustomNavigation from "../Carousel/carousel";

export default function Index() {
  return (
<>

<ComplexNavbar/>    
<CarouselCustomNavigation/>


<Gallery/>
<Card/>
<MainGaller/>

<Feature />



<Footer/>

</>


  )
}
